import React from 'react'
import ChipOptionField from '../../../../../../common/inputs/chipOptionField/ChipOptionField'
import { FieldProps, YesNoOrByAppointmentString } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'

const LanCablesField: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  insertionData,
  onChange,
  screenName,
}) => {
  return (
    <ChipOptionField
      id='lan-cables'
      propertyName='lanCables'
      option={insertionData.lanCables}
      options={YesNoOrByAppointmentString}
      translation='wizard.screen.otherFacilities.'
      labelTranslationKey='wizard.screen.otherFacilities.lanCables'
      onChange={(value) => onChange({ screen: screenName, property: 'lanCables' }, value)}
    />
  )
}

export default LanCablesField
